import { Box, IconButton, InputAdornment, SxProps, Theme } from '@mui/material';
import React, { useImperativeHandle } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import './scss/search-input.style.scss';
import BaseInput from './base-input.component';
import { pillFilterSearchBoxSx } from '../pill-filter-control-sx';


// *****************
// TYPE
// *****************
type searchProps = {
    /** 回车、点击搜索图标、清空或输入被删至空时触发（非受控，值为当前框内文案） */
    onSearch: (value: string) => void;
    /** 是否显示尾部清除按钮 */
    allowClear?: boolean;
    /** 输入变化时回调（含未提交搜索的每一次输入） */
    onChange?: (value: string) => void;
    /** 追加在根节点 `search-box` 上的类名，便于页面局部覆写样式 */
    className?: string;
    /** 非受控初始文案（仅首次挂载生效，用于与外层已提交关键词对齐） */
    initialValue?: string;
    /** 占位提示 */
    placeholder?: string;
    /** 为 true 时使用与 PrefixLabeledPillSelect 一致的药丸外观 */
    pillStyle?: boolean;
};

// *****************
// 搜索框
// *****************
function SearchComponent(
    // 输入框属性
    props: searchProps,
    ref: React.ForwardedRef<unknown>
) {
    const { allowClear, onSearch, onChange, className, initialValue = '', placeholder, pillStyle } = props;
    /** 药丸样式时覆盖 scss 默认 max-width */
    const rootSx: SxProps<Theme> | undefined = pillStyle ? pillFilterSearchBoxSx : undefined;
    /** 输入框当前值（非受控） */
    const [searchValue, setSearchValue] = React.useState<string>(() => initialValue);
    useImperativeHandle(ref, () => ({
        setSearchValue: (val: string) => void setSearchValue(val),
    }));
    return (
        <Box className={`search-box${pillStyle ? ' search-box--pill' : ''}${className ? ` ${className}` : ''}`} sx={rootSx}>
            <BaseInput
                className={`searchInput`}
                placeholder={placeholder}
                onChange={(event) => {
                    event.stopPropagation();
                    const value = event.target.value;
                    const str = value.replace(/(^\s*)|(\s*$)/g, '');
                    onChange?.(value);
                    // 搜索值为空时重新请求数据
                    if (str === '' || str === undefined || str == null) {
                        setSearchValue(value);
                        onSearch(value);
                    } else {
                        setSearchValue(value);
                    }
                }}
                id='standard-start-adornment'
                size={'small'}
                value={searchValue}
                onKeyDown={(e) => {
                    e.stopPropagation()
                    if (e.key === 'Enter') {
                        onChange?.(searchValue);
                        onSearch(searchValue);
                    }
                }}
                autoComplete={'off'}
                InputProps={{
                    startAdornment: (
                        <InputAdornment
                            position='start'
                        >
                            <IconButton
                                className='searchIconBtn'
                                onClick={() => {
                                    onSearch(searchValue)
                                }}
                            >
                                <SearchIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        searchValue !== '' && allowClear &&
                        <InputAdornment position='end'>
                            <IconButton
                                className='searchIconBtn'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSearchValue('');
                                    onChange?.('');
                                    onSearch('');
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            // startAdornment={
            //     <InputAdornment
            //         position="start"
            //     >
            //         <IconButton
            //             className="searchIconBtn"
            //             onClick={() => {
            //                 onSearch(searchValue)
            //             }}
            //         >
            //             <SearchIcon />
            //         </IconButton>
            //     </InputAdornment>
            // }
            // endAdornment={
            //     searchValue !== '' && allowClear &&
            //     <InputAdornment position="end">
            //         <IconButton
            //             className="searchIconBtn"
            //             onClick={(e) => {
            //                 e.stopPropagation();
            //                 setSearchValue('');
            //                 onChange?.('');
            //                 onSearch('');
            //             }}
            //         >
            //             <CloseIcon />
            //         </IconButton>
            //     </InputAdornment>
            // }

            />
        </Box>
    )
}

export default React.forwardRef(SearchComponent);
